
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { ExternalUser } from '@/models/externalUser';
import { externalUserWebservice } from '@/webservices/externalUser';
import type { Project } from '@/models/project';
import Divider from '@/components/layout/Divider.vue';

@Component({
    name: 'AddExternalUsers',
    components: { Divider },
})
export default class AddExternalUsers extends Vue {
    private isModalActive: boolean = false;
    private errors: string[] = [];
    private externalUser: ExternalUser = {} as ExternalUser;

    @Prop() private project: Project;

    private mounted() {
        this.externalUser.project_id = this.project.id;
        this.externalUser.firstname = '';
        this.externalUser.lastname = '';
        this.externalUser.email = '';
        this.externalUser.tenant = '';
    }

    private toggleModal() {
        this.isModalActive = !this.isModalActive;
    }

    private checkError(errorKey: string) {
        return this.errors.includes(errorKey);
    }

    private store() {
        if (!this.verification()) {
            return;
        }

        externalUserWebservice
            .store(this.externalUser)
            .then((res) => {
                this.$emit('reload', res);
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.store.externalUser').toString(),
                    type: 'is-success',
                });
                this.toggleModal();
                this.externalUser = {} as ExternalUser;
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private verification(): boolean {
        this.externalUser.email = this.externalUser.email.trim();
        this.externalUser.firstname = this.externalUser.firstname.trim();
        this.externalUser.lastname = this.externalUser.lastname.trim();

        this.errors = [];

        if (!this.externalUser.tenant && !this.externalUser.firstname && !this.externalUser.lastname) {
            this.errors.push('name');
        }

        if (!this.externalUser.email || !this.validateEmail(this.externalUser.email)) {
            this.errors.push('email');
        }

        return this.errors.length === 0;
    }

    private validateEmail(email: string) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }
}
